import { Layout, Text } from '@loadsmart/miranda-react'

import { type TrackingMethod } from '../../../domain/Tracking'
import { formatTrackingMethodName } from '../../../presenters/preferredTrackingMethod'
import { ProvidersBadge } from '../ProvidersBadge'
import SelectableBox from './SelectableBox'

export type TrackingMethodCardProps = {
  readonly method: TrackingMethod
  readonly selected?: boolean
  readonly onClick: () => void
}

export default function TrackingMethodCard({
  method,
  selected = false,
  onClick,
}: TrackingMethodCardProps) {
  return (
    <SelectableBox selected={selected} onClick={onClick}>
      <Layout.Stack align="center" gap="spacing-2">
        <ProvidersBadge methods={[method]} />
        <Text variant="body-sm" color="color-text-tertiary">
          {formatTrackingMethodName(method)}
        </Text>
      </Layout.Stack>
    </SelectableBox>
  )
}
